export default __webpack_public_path__ + "static/media/order-step6.251d9d66.svg";